"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _typeof = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
require("E:\\dianlala_project\\\u7535\u5566\u5566\\cd-vue-admin\\node_modules\\core-js\\modules\\es6.array.iterator.js");
require("E:\\dianlala_project\\\u7535\u5566\u5566\\cd-vue-admin\\node_modules\\core-js\\modules\\es6.promise.js");
require("E:\\dianlala_project\\\u7535\u5566\u5566\\cd-vue-admin\\node_modules\\core-js\\modules\\es6.object.assign.js");
require("E:\\dianlala_project\\\u7535\u5566\u5566\\cd-vue-admin\\node_modules\\core-js\\modules\\es7.promise.finally.js");
var _vue = _interopRequireDefault(require("vue"));
require("normalize.css/normalize.css");
var _elementUi = _interopRequireDefault(require("element-ui"));
var _en = _interopRequireDefault(require("element-ui/lib/locale/lang/en"));
require("@/styles/index.scss");
var _App = _interopRequireDefault(require("./App"));
var _store = _interopRequireDefault(require("./store"));
var _router = _interopRequireDefault(require("./router"));
require("@/icons");
require("@/permission");
var _request = require("./utils/request");
var _adminOperationReport = require("./utils/adminOperationReport");
var equipmentReport = _interopRequireWildcard(require("./utils/reports/equipmentReport"));
var agentReport = _interopRequireWildcard(require("./utils/reports/agentReport"));
var userReport = _interopRequireWildcard(require("./utils/reports/userReport"));
var withdrawReport = _interopRequireWildcard(require("./utils/reports/withdrawReport"));
var orderReport = _interopRequireWildcard(require("./utils/reports/orderReport"));
var shopReport = _interopRequireWildcard(require("./utils/reports/shopReport"));
var adReport = _interopRequireWildcard(require("./utils/reports/adReport"));
var settingReport = _interopRequireWildcard(require("./utils/reports/settingReport"));
var customerRecordReport = _interopRequireWildcard(require("./utils/reports/customerRecordReport"));
var permissionReport = _interopRequireWildcard(require("./utils/reports/permissionReport"));
var feedbackReport = _interopRequireWildcard(require("./utils/reports/feedbackReport"));
var _dataView = _interopRequireDefault(require("@jiaminghi/data-view"));
var _index2 = require("./utils/index");
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// A modern alternative to CSS resets

// lang i18n

// global css

// icon
// permission control

/**
 * 【操作埋点】2026-05-25
 * 说明：各模块上报方法挂到 Vue 原型；页面用 $post(url, data, reportMeta) 或 this.$xxxReport.xxx() 触发
 */

// 导入各模块埋点方法

_vue.default.prototype.$get = _request.$get;
_vue.default.prototype.$getZip = _request.$getZip;
_vue.default.prototype.$post = _request.$post;
_vue.default.prototype.$delete = _request.$delete;
_vue.default.prototype.$put = _request.$put;
_vue.default.prototype.$reportAdminOperation = _adminOperationReport.reportAdminOperation;
_vue.default.prototype.$buildAdminOperationReportMeta = _adminOperationReport.buildAdminOperationReportMeta;
_vue.default.prototype.$withAdminOperationReport = _adminOperationReport.withAdminOperationReport;

// 【操作埋点】2026-05-25 注册各模块埋点方法到 Vue 原型
_vue.default.prototype.$equipmentReport = equipmentReport;
_vue.default.prototype.$agentReport = agentReport;
_vue.default.prototype.$userReport = userReport;
_vue.default.prototype.$withdrawReport = withdrawReport;
_vue.default.prototype.$orderReport = orderReport;
_vue.default.prototype.$shopReport = shopReport;
_vue.default.prototype.$adReport = adReport;
_vue.default.prototype.$settingReport = settingReport;
_vue.default.prototype.$customerRecordReport = customerRecordReport;
_vue.default.prototype.$permissionReport = permissionReport;
_vue.default.prototype.$feedbackReport = feedbackReport;
(0, _adminOperationReport.setAdminOperationRouter)(_router.default);
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  var _require = require("../mock"),
    mockXHR = _require.mockXHR;
  mockXHR();
}
_vue.default.prototype.parseTime = _index2.parseTime;
_vue.default.prototype.todays = _index2.todays;
_vue.default.prototype.pick = _index2.pick;
_vue.default.prototype.checkRoles = _index2.checkRoles;
_vue.default.prototype.outTab = _index2.outTab;
_vue.default.prototype.formErrow = _index2.formErrow;
_vue.default.prototype.arrayKeys = _index2.arrayKeys;
_vue.default.prototype.pickKeys = _index2.pickKeys;
_vue.default.prototype.checkHidRole = _index2.checkHid;

// set ElementUI lang to EN
_vue.default.use(_elementUi.default);
_vue.default.use(_dataView.default);
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

_vue.default.config.productionTip = false;
(0, _index2.setRem)();

// 改变窗口大小时重新设置 rem
window.onresize = function () {
  (0, _index2.setRem)();
};
var startApp = function startApp() {
  _axios.default.get('/config.json').then(function (res) {
    // 基础地址
    _vue.default.prototype.BASE_URL = res.data.BASE_URL;
    _vue.default.prototype.DEVICDE_CODE_URL = res.data.DEVICDE_CODE_URL;
    _vue.default.prototype.config = res.data;
    new _vue.default({
      el: '#app',
      router: _router.default,
      store: _store.default,
      render: function render(h) {
        return h(_App.default);
      }
    });

    // if(res.data.baidu_statistics){
    //  router.beforeEach((to, from, next) => {
    //   setTimeout(() => {
    //     eval(res.data.baidu_statistics)
    //    }, 50)
    //    next()
    //  })
    //}
  });
};
startApp();